export const customerContextQueryKey = ["customerContextGetContext"] as const;
